import { createContext } from "react"

import { ApiCommunityRecipe } from "~/models/CommunityRecipe"

interface IRecipeContext {
  recipe: ApiCommunityRecipe
  refetchRecipe: () => void
}

export const RecipeContext = createContext<IRecipeContext | null>(null)
